// src/components/PricingSection.jsx
import React from "react";

const PricingSection = () => {
  return (
    <section
      style={{
        background: "linear-gradient(160deg, #071520 0%, #0a1e2e 35%, #071018 100%)",
        paddingTop: "0",
        paddingBottom: "64px",
        paddingLeft: "24px",
        paddingRight: "24px",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <p
        style={{
          textAlign: "center",
          fontSize: "11px",
          fontWeight: 500,
          letterSpacing: "3px",
          textTransform: "uppercase",
          color: "rgba(64,190,180,0.6)",
          marginBottom: "20px",
        }}
      >
        Service Charges
      </p>

      <div
        style={{
          maxWidth: "640px",
          margin: "0 auto",
          background: "rgba(10, 25, 40, 0.92)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(64,190,180,0.15)",
          borderRadius: "14px",
          padding: "24px 32px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Subtle top accent */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: "120px",
            height: "1px",
            background: "linear-gradient(90deg, transparent, rgba(64,190,180,0.35), transparent)",
          }}
        />

        <p
          style={{
            color: "rgba(255,255,255,0.45)",
            fontSize: "13.5px",
            lineHeight: "1.9",
            margin: 0,
            textAlign: "center",
          }}
        >
          This platform provides Aadhaar-based identity verification services through DigiLocker
          for KYC purposes. This service is provided free of charge to all users. There are no
          registration fees, transaction charges, subscriptions, or any other costs applicable
          to end users at any stage of the KYC verification process.
        </p>
      </div>
    </section>
  );
};

export default PricingSection;
